<ng-container *transloco="let t; prefix: this.scope">
  <form class="tabbed-dialog-layout" [formGroup]="firmDataForm" (ngSubmit)="updateFirmData()">
    <main class="tabbed-dialog-body flex w-full">
      <section class="relative w-1/2">
        <div class="flex flex-col mb-2">
          <h4>{{ firmData.name }}</h4>
          <p class="font-semibold text-bl-grey text-lg">{{ firmData.corporateIdentity }}</p>
        </div>
        <bl-frontend-text-input
          id="address"
          [text]="t('address')"
          formControlName="address"
          name="firm_adress"
          class="w-full"
          [placeholder]="t('enterAddress')" />
        <div class="flex gap-2 mt-3">
          <div class="w-1/4">
            <bl-frontend-text-input
              id="zipcode"
              [text]="t('zipCode')"
              formControlName="zipcode"
              name="firm_zipcode"
              [placeholder]="t('enterZipCode')"></bl-frontend-text-input>
          </div>
          <div class="w-3/4">
            <bl-frontend-text-input
              id="city"
              [text]="t('city')"
              formControlName="city"
              name="firm_city"
              [placeholder]="t('enterCity')"></bl-frontend-text-input>
          </div>
        </div>
        <div class="mt-3">
          <bl-frontend-text-input
            id="email"
            [text]="t('email')"
            formControlName="email"
            name="firm_email"
            [placeholder]="t('enterEmail')"></bl-frontend-text-input>
        </div>
        <div class="mt-3">
          <bl-frontend-text-input
            id="phone"
            [text]="t('phone')"
            formControlName="phone"
            name="firm_phone"
            [placeholder]="t('enterPhone')"></bl-frontend-text-input>
        </div>
        <div class="mt-3" formGroupName="properties">
          <h5 class="leading-tight text-bl-grey">{{ t('other') }}</h5>
          <p-checkbox
            *appHideIfCountries="'NL'"
            [binary]="true"
            formControlName="include_activities_for_archived_clients"
            [label]="t('includeActivitiesForArchivedClients')"></p-checkbox>
          <p-checkbox
            class="mt-3"
            [binary]="true"
            formControlName="show_hidden_databases_for_all_users"
            [label]="t('showHiddenDatabasesForAllUsers')"></p-checkbox>
        </div>
      </section>
    </main>
    <div class="tabbed-dialog-actions flex justify-end p-4 bg-bl-grey-100">
      <bl-frontend-button
        type="submit"
        [disabled]="!formValueChanged()"
        [text]="t('saveFirmDetails')"></bl-frontend-button>
    </div>
  </form>
</ng-container>
